import { defineComponent as i, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as V, createElementVNode as l, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, v = { key: 2 }, A = { key: 3 }, M = { key: 4 }, f = { key: 5 }, h = {
  name: "ScalarIconAlignRightSimple"
}, y = /* @__PURE__ */ i({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: H, weight: n } = u(s);
    return (d, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(H)), [
      V(d.$slots, "default"),
      e(n) === "bold" ? (a(), o("g", Z, t[0] || (t[0] = [
        l("path", { d: "M236,56V200a12,12,0,0,1-24,0V56a12,12,0,0,1,24,0ZM196,96v64a20,20,0,0,1-20,20H32a20,20,0,0,1-20-20V96A20,20,0,0,1,32,76H176A20,20,0,0,1,196,96Zm-24,4H36v56H172Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        l("path", {
          d: "M192,96v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H184A8,8,0,0,1,192,96Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M232,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM200,96v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80H184A16,16,0,0,1,200,96Zm-16,0H32v64H184Z" }, null, -1)
      ]))) : e(n) === "fill" ? (a(), o("g", v, t[2] || (t[2] = [
        l("path", { d: "M232,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM184,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V96A16,16,0,0,0,184,80Z" }, null, -1)
      ]))) : e(n) === "light" ? (a(), o("g", A, t[3] || (t[3] = [
        l("path", { d: "M230,56V200a6,6,0,0,1-12,0V56a6,6,0,0,1,12,0ZM198,96v64a14,14,0,0,1-14,14H32a14,14,0,0,1-14-14V96A14,14,0,0,1,32,82H184A14,14,0,0,1,198,96Zm-12,0a2,2,0,0,0-2-2H32a2,2,0,0,0-2,2v64a2,2,0,0,0,2,2H184a2,2,0,0,0,2-2Z" }, null, -1)
      ]))) : e(n) === "regular" ? (a(), o("g", M, t[4] || (t[4] = [
        l("path", { d: "M232,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM200,96v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80H184A16,16,0,0,1,200,96Zm-16,0H32v64H184Z" }, null, -1)
      ]))) : e(n) === "thin" ? (a(), o("g", f, t[5] || (t[5] = [
        l("path", { d: "M228,56V200a4,4,0,0,1-8,0V56a4,4,0,0,1,8,0ZM196,96v64a12,12,0,0,1-12,12H32a12,12,0,0,1-12-12V96A12,12,0,0,1,32,84H184A12,12,0,0,1,196,96Zm-8,0a4,4,0,0,0-4-4H32a4,4,0,0,0-4,4v64a4,4,0,0,0,4,4H184a4,4,0,0,0,4-4Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
